import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function YocoPayment({ courseId, courseName, packageType = 'course', planId, onSuccess }) {
  const [loading, setLoading] = useState(false);

  const handlePayment = async () => {
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      
      const checkoutResponse = await fetch(`${API}/payments/checkout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          package_type: packageType,
          course_id: courseId,
          plan_id: planId
        })
      });

      if (!checkoutResponse.ok) {
        const error = await checkoutResponse.json();
        throw new Error(error.detail || 'Failed to initiate payment');
      }

      const checkoutData = await checkoutResponse.json();

      if (checkoutData.redirect_url) {
        // Redirect to Yoco hosted checkout page
        window.location.href = checkoutData.redirect_url;
      } else {
        throw new Error('No redirect URL received from payment gateway');
      }
    } catch (error) {
      console.error('Payment error:', error);
      toast.error(error.message || 'Payment failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={handlePayment}
      disabled={loading}
      className="w-full bg-[#D9C7A3] text-[#0B0B0B] hover:bg-[#C6A97C] rounded-full py-6 text-lg font-bold"
      data-testid="yoco-payment-btn"
    >
      {loading ? 'Redirecting to Payment...' : `Pay with Yoco`}
    </Button>
  );
}
